import * as React from 'react'

import type { FeaturedItemsCardViewModel } from '../../view-models/FeaturedItemsCardViewModel'
import FeaturedItemCard from '../FeaturedItemCard/FeaturedItemCard'
import styles from './featuredItemCardGrid-style.css'

export type FeaturedItemCardGridProps = {
  items: Array<FeaturedItemsCardViewModel>
  eventName: string
}

function FeaturedItemCardGrid({ items, eventName }: FeaturedItemCardGridProps) {
  if (!items) return null

  return (
    <div className={styles.featuredItemsGrid}>
      {items.map((item, index) => (
        <FeaturedItemCard
          key={index}
          eventName={eventName}
          {...item}
        />
      ))}
    </div>
  )
}

FeaturedItemCardGrid.displayName = 'FeaturedItemCardGrid'
FeaturedItemCardGrid.defaultProps = {}
export default FeaturedItemCardGrid
